$ ->
  header = $ '#header'

  hide = -> header.find('.flash').addClass 'hide'
  timeout = window.setTimeout hide, 5000

  header.find('.remove').on 'click', -> hide()

